"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const brown_1 = __importDefault(require("@material-ui/core/colors/brown"));
const green_1 = __importDefault(require("@material-ui/core/colors/green"));
const yellow_1 = __importDefault(require("@material-ui/core/colors/yellow"));
const red_1 = __importDefault(require("@material-ui/core/colors/red"));
const general_1 = __importDefault(require("./general"));
const overrides_1 = __importDefault(require("./overrides"));
const Gidole_1 = __importDefault(require("./fonts/Gidole"));
const theme = styles_1.createMuiTheme(general_1.default, {
    palette: {
        primary: {
            main: '#014534',
            light: '#025e47',
            dark: '#124634',
            100: '#F4FAF8',
        },
        secondary: {
            ...brown_1.default,
            main: brown_1.default[500],
            light: brown_1.default[300],
            dark: brown_1.default[700],
        },
        text: {
            primary: '#212529',
            secondary: 'rgba(33, 37, 41, 0.8)',
        },
        background: {
            paper: '#fff',
            default: '#F4FAF8',
        },
        results: {
            bad: {
                main: red_1.default[500],
                light: red_1.default[200],
                dark: red_1.default[800],
            },
            caution: {
                main: yellow_1.default[500],
                light: yellow_1.default[200],
                dark: yellow_1.default[800],
            },
            good: {
                main: green_1.default[500],
                light: green_1.default[200],
                dark: green_1.default[800],
            },
        },
    },
    typography: {
        fontSize: 16,
        fontFamily: 'Gidole, Arial',
        h1: {
            fontWeight: 400,
            // textTransform: "uppercase"
        },
        h2: {
            fontWeight: 400,
        },
        h3: {
            fontWeight: 400,
        },
        h5: {
            fontSize: 22,
            fontWeight: 400,
        },
        subtitle1: {},
        body1: {
            fontWeight: 400,
        },
        button: {
            // fontStyle: "italic"
            fontWeight: 500,
            textTransform: 'none',
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': Gidole_1.default,
                // a: {
                //   color: palette.primary.main,
                //   textDecoration: 'none',
                //   '&:hover': {
                //     textDecoration: 'underline',
                //   },
                // },
                // ".MuiFilledInput-root.Mui-focused": {
                //   backgroundColor: "rgba(255, 255, 255, 0.95)"
                // }
            },
        },
    },
});
exports.default = styles_1.responsiveFontSizes(overrides_1.default(theme));
//# sourceMappingURL=data:application/json;base64,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